import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, FormSection, formValueSelector,reset } from "redux-form";
import {   Button, Spinner,Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Banner from "../common/banner";
import {Loading,LoadingDone,Reset,Success,Error} from "../../actions/loading"
import { renderInput, renderTextArea, renderDatePicker, renderDropdown, renderMultiselect, renderCheckbox } from "../common/renderinput";
import axios from "axios";
import appConfig from '../../config/config';
import DropdownList from 'react-widgets/lib/DropdownList';

var q = [
    
];
const divStyle = {
    backgroundColor: '#fff'
};
const padStyle = {
    paddingTop: '5px', paddingLeft : '0px'
};
class AddOrderStatus extends Component {
    constructor(...args) {
        super(...args);
        this.state = {
            display:true
        };
    }
    toggle = (val) => {
        this.setState({...this.state, display : !val})
    }

    load() {
        this.props.Loading();
        axios.post(
            appConfig.apiGateway.searchOrderUrl,
            JSON.stringify({  Action: "AllStatus" }),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                }
            }
        ).then(response => {
            this.props.LoadingDone();
            JSON.parse(response.data.body).map( (i) => {
                q.push( {valueField : i.ID, textField : i.NAME} )
            } 
            )
        }, error => {
            this.props.LoadingDone();
        });
    }
    componentDidMount() {
        this.load()
    }
    submit = (values) => {
      this.props.Loading()
      axios.post(
        appConfig.apiGateway.updateOrderUrl,
        JSON.stringify({
            ...values, 
            OrderProductId: this.props.OrderProductId,
            Action: "AddStatus",
            UserName: this.props.session.session.user.name
        }),
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
            }
        }
    ).then((response) => { 
                          this.props.LoadingDone()
                          if (!(response.hasOwnProperty('data') && response.data.hasOwnProperty('body'))) {
                            this.props.Error('Invalid params')
                            return;
                          }
                          if (response.data.body.status) {
                            this.props.Success('Status Added')
                            this.props.Refresh()
                            this.props.Add(false)
                          }
                          else {
                            this.props.Error(response.data.body.message)
                          }
                        },
                        (error)=>{
                            this.props.LoadingDone()
                            this.props.Error('Unable to add status')
                          }
    )}
    render() {
        return (
          <>
            <div>
              <Modal
                isOpen={this.state.display}
                toggle={this.toggle}
                contentClassName="custom-modal-style"
              >
                <form
                  onSubmit={this.props.handleSubmit(this.submit)}
                  style={{ marginLeft: "0%", marginRight: "5%" }}
                >
                  <ModalHeader>Add Status</ModalHeader>
                  <ModalBody>
                    {this.props.loading.showBanner && (
                      <Banner
                        Close={this.props.Reset}
                        message={this.props.loading.message}
                        IsSuccess={this.props.loading.isSuccess}
                      />
                    )}
                    <div className="form-row col-12" style={padStyle}>
                      <div className="col-12" style={divStyle}>
                        <Field name="Status" component={renderDropdown} label="Status" data={q} 
                        textField="textField" valueField="valueField" isLabel={true} />

                      </div>
                    </div>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="primary" type="submit">
                      {this.props.loading.loading == true && <Spinner />}
                      {!this.props.loading.loading == true && <span>Save</span>}
                    </Button>
                    <Button
                      color="secondary"
                      onClick={() => this.props.Add(false)}
                    >
                      Cancel
                    </Button>
                  </ModalFooter>
                </form>
              </Modal>
            </div>
          </>
        );}
}
const validate = (formValues) => {
    const errors = {};
    
    return errors;
}
var addOrderStatus = reduxForm({
    form: 'orderStatusForm',
    validate
})(AddOrderStatus);

addOrderStatus = connect(
    state => ({
        session: state.session,
        loading : state.loading
    }),{LoadingDone,Loading,Success,Error,Reset}
)(addOrderStatus);

export default addOrderStatus;